import React from "react";
import { SectionTitle } from "@/components/dashboard/widgets";
import TwoFactorSection from "@/components/dashboard/TwoFactorSection";

/**
 * Admin Security page — currently houses TOTP 2FA enrolment + management.
 * The actual UI lives in the re-usable TwoFactorSection so non-admin roles
 * can self-serve 2FA from their Settings page.
 */
export default function AdminSecurity() {
  return (
    <div className="space-y-6">
      <SectionTitle title="Security" subtitle="Two-factor authentication and account-level protections." />
      <TwoFactorSection
        title="Two-factor authentication (TOTP)"
        copyHint="Add a second factor (Google Authenticator, 1Password, Authy) to your sign-in. Required by Connexis policy for all admin accounts handling buyer or compliance data."
      />
    </div>
  );
}
